import { Reveal } from "@/components/site/motion";
import { Eyebrow } from "@/components/site/primitives";

export const Section = ({ children, className = "", light = false, id, wide = false }) => (
  <section id={id} className={`${light ? "bg-bone text-ink" : "bg-ink text-bone"} ${className}`}>
    <div className={`mx-auto ${wide ? "max-w-[1600px]" : "max-w-[1400px]"} px-5 py-20 md:px-10 md:py-28`}>{children}</div>
  </section>
);

export const PageHero = ({ eyebrow, title, lead, children, light = false }) => (
  <section className={`relative overflow-hidden ${light ? "bg-bone text-ink" : "bg-ink text-bone grain"} border-b ${light ? "border-ink/10" : "border-white/10"}`}>
    {!light && <div className="hairgrid pointer-events-none absolute inset-0 opacity-40" />}
    <div className="relative mx-auto max-w-[1400px] px-5 pb-16 pt-32 md:px-10 md:pb-24 md:pt-44">
      <Reveal>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1
          className={`mt-6 max-w-4xl text-balance font-serif text-4xl leading-[1.02] tracking-tighter md:text-6xl lg:text-[68px] ${
            light ? "text-ink" : "text-bone"
          }`}
        >
          {title}
        </h1>
        {lead && (
          <p className={`mt-8 max-w-2xl text-lg leading-[1.6] md:text-xl ${light ? "text-ink/70" : "text-mist"}`}>{lead}</p>
        )}
        {children && <div className="mt-10 flex flex-wrap items-center gap-4">{children}</div>}
      </Reveal>
    </div>
  </section>
);

export const Pill = ({ children, tone = "default" }) => {
  const tones = {
    default: "border-white/15 text-mist",
    signal: "border-signal/40 text-signal",
    saffron: "border-saffron/40 text-saffron",
    dark: "border-ink/20 text-ink/60",
  };
  return (
    <span className={`inline-flex items-center gap-2 border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.16em] ${tones[tone]}`}>
      {children}
    </span>
  );
};
